import './App.css';
import Typewriter from 'typewriter-effect';
import { FaLinkedin, FaGithub } from "react-icons/fa";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div style={{ marginBottom: '30px' }}>
          <Typewriter
            onInit={(typewriter) => {
              typewriter.typeString('Hello World!').start();
            }}
          />
        </div>

        <div className="social-icons">
          <a
            href="https://www.linkedin.com/in/shanon-coles"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin className="icon linkedin" />
          </a>

          <a
            href="https://github.com/importutil"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub className="icon github" />
          </a>
        </div>
      </header>
    </div>
  );
}

export default App;